import React, {Component} from "react";

import axios from 'axios';
import history from '../../../history';
import AuthActions from '../../../actions/AuthActions';
import AuthStore from '../../../stores/AuthStore';
import Constants from '../../../components/Constants/';
import FileBase64 from 'react-file-base64';
import Select from 'react-select';import {Async} from 'react-select';
import $ from 'jquery';

import AlertContainer from 'react-alert';

import classnames from "classnames";

import {
    Row,
    Col,
    Button,
    Label,
    Input,
    Link,
    Table,
    Badge,
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

//Campo de data
import DayPickerInput from 'react-day-picker/DayPickerInput';
//import { formatDate, parseDate } from 'react-day-picker/moment';
import moment from 'moment';
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';
import 'moment/locale/pt-br';

import 'react-day-picker/lib/style.css';
import Dropzone from 'react-dropzone'

class ExamForm extends Component {

  constructor(props) {
    super(props);

    this.updateInputValue = this.updateInputValue.bind(this);
    this.updateCheckboxValue = this.updateCheckboxValue.bind(this);
    this.updatePatientInputValue = this.updatePatientInputValue.bind(this);
    this.updateCheckboxValue = this.updateCheckboxValue.bind(this);
    this.updateSelectValue = this.updateSelectValue.bind(this);
    this.updatePatientSelectValue = this.updatePatientSelectValue.bind(this);
    this.onDrop = this.onDrop.bind(this);

    this.sendExam = this.sendExam.bind(this);

    this.onAntecedentSelect = this.onAntecedentSelect.bind(this);
    this.onSymptomSelect = this.onSymptomSelect.bind(this);

    this.handleDateChange = this.handleDateChange.bind(this);
    this.toggleTab = this.toggleTab.bind(this);

    this.showAlert = this.showAlert.bind(this);

    this.handleKeyDownDayInput = this.handleKeyDownDayInput.bind(this);
    
    this.state = {
        activeTab: '1',
        value: [],
        antecedentList: [],
        symptomList: [],
        speciallityList: [],
        lastPatientList: [],
        xmlFile: undefined,
        selectAntecedentValue: [],
        selectSymptomValue: [],
        buttonActive: true,
        formDtBirthDate: "",

        exam: {
          status: "EXAM_STATUS_CREATED",
          patient: {
            document: "",
            docType: null,
            firstname: "",
            lastname: "",
            dtBirthDate: null,
            gender: null,
            motherName: "",
            contactPhone: "",
            weight: 0,
            height: 0
          },
          requesterName: "",
          requesterContactPhone: "",
          requesterSpeciallity: {},

          patientAntecedents: [{}],
          otherPatientAntecedents: "",
          patientSymptoms: [{}],
          otherPatientSymptoms: "",

          equipType: null,
          ecgData: null,

          ecgSampleRate: 0,
          ecgResolution: 0,

          urgent: false,
          obs: "",

          saturation: 0,
          frequency: 0,
          paSistolic: 0,
          paDiastolic: 0,


          client: {

          },
          examType: 'EXAM_TYPE_ECG'
        }
    };

    /*
    * Configurações do alerta
    */
    this.alertOptions = {
      offset: 14,
      position: 'top right',
      theme: 'light',
      time: 10000,
      transition: 'scale'
    }
  }

  componentDidMount(){

    axios({
        method: 'get',
        url: Constants.apiUrl+'/api/v1/symptom'
    })
    .then(response => {

      let symptoms = [];
      response.data.forEach(function(symptom) {
        symptoms.push({
          value: symptom.id,
          label: symptom.description
        });
      });

      this.setState({
          "symptomList": symptoms
      });

    });

    axios({
        method: 'get',
        url: Constants.apiUrl+'/api/v1/antecedent'
    })
    .then(response => {

      let antecedents = [];
      response.data.forEach(function(antecedent) {
        antecedents.push({
          value: antecedent.id,
          label: antecedent.description
        });
      });

      this.setState({
          "antecedentList": antecedents
      });
    });

    axios({
        method: 'get',
        url: Constants.apiUrl+'/api/v1/speciality'
    })
    .then(response => {

      let speciallities = [];
      response.data.forEach(function(speciallity) {
        speciallities.push({
          value: speciallity.id,
          label: speciallity.description
        });
      });

      this.setState({
          "speciallityList": speciallities
      });
    });

  }

  showAlert(message){
    this.msg.show(message, {
      time: 10000,
      type: 'error'
    });
  }

  onAntecedentSelect (value) {
    this.setState({ selectAntecedentValue: value });
  }

  onSymptomSelect (value) {
    this.setState({ selectSymptomValue: value });
  }

  sendExam(){

    if(this.state.exam.patient.docType == null || this.state.exam.patient.docType == 'NULL') {
      this.showAlert("Selecione o tipo do documento do paciente."); return;
    }

    if(this.state.exam.patient.gender == null || this.state.exam.patient.gender == 'NULL') {
      this.showAlert("Selecione o sexo do paciente."); return;
    }

    this.setState({"buttonActive": false});

    let antecedents = [];
    let symptoms = [];
    let tokens = "";

    if(this.state.selectAntecedentValue != ""){
      tokens = this.state.selectAntecedentValue.split(',');
      tokens.forEach(function(antecedent) {
        antecedents.push({id: antecedent});
      }, this);
    }
    if(this.state.selectSymptomValue != ""){
      tokens = this.state.selectSymptomValue.split(',');
      tokens.forEach(function(symptom) {
        symptoms.push({id: symptom});
      }, this);
    }

    let client = {
      "id": AuthStore.getState().user.entity_id
    };

    let patient = this.state.exam.patient;
    patient.dtBirthDate = moment(new Date(this.state.formDtBirthDate)).format('YYYY-MM-DD');


    let actualExam = this.state.exam;
    actualExam.patient = patient;

    //data de criação do exame
    actualExam.dtExecution = new Date();

    actualExam.patientAntecedents = antecedents;
    actualExam.patientSymptoms = symptoms;
    actualExam.client = client;

    this.setState({"exam": actualExam}, function(){

      //console.log(actualExam);

      var formData = new FormData();
      formData.append("xmlFile", this.state.xmlFile);
      formData.append("exam", JSON.stringify(this.state.exam));

      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/exam/import',
          data: formData,
          //{"exam": this.state.exam, "xmlFile": xmlFile.files[0]},
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      })
      .then(response => {
         //console.log(response);
         history.replace("dashboard");
      })
      .catch(error => {
        this.setState({"buttonActive": true});
        this.showAlert("Ocorreu um erro ao enviar o exame. Verifique a integridade do arquivo e o formato da data de nascimento do paciente.");
      });
    });
  }

  updateInputValue(evt, input) {
    let actualExam = this.state.exam;
    actualExam[input] = evt.target.value;

    this.setState({
      exam: actualExam
    });
  }

  updatePatientInputValue(evt, input) {
    let actualExam = this.state.exam;
    actualExam.patient[input] = evt.target.value;

    this.setState({
      exam: actualExam
    });
  }

  updateCheckboxValue(evt, input) {
    let actualExam = this.state.exam;
    actualExam[input] = !actualExam[input];

    this.setState({
      exam: actualExam
    });
  }

  updateSelectValue(newValue) {
    let actualExam = this.state.exam;
    actualExam.requesterSpeciallity.id = newValue;

    this.setState({
      exam: actualExam
    });
  }

  updatePatientSelectValue(newValue) {
    if(newValue != null && newValue != undefined  && newValue != "" )
    axios({
        method: 'get',
        url: Constants.apiUrl+'/api/v1/patient/id/'+newValue
    })
    .then(response => {

      let patient = response.data;
      //patient.dtBirthDate = new Date(patient.dtBirthDate);

      let actualExam = this.state.exam;
      actualExam.patient = patient;

      this.setState({
        exam: actualExam,
        formDtBirthDate: new Date(patient.dtBirthDate)
      });
    });
  }

  getOptions(input, callback){

    if(input != null && input != "" && input.length >= 3){
      this.setState({"isLoading": true}, function() {

        //Busca Pacientes por Cliente ao ENTER
        axios({
            method: 'get',
            url: Constants.apiUrl+'/api/v1/patient/client/'+AuthStore.getState().user.entity_id+"/"+input
        })
        .then(response => {

          let patients = [];
          patients.push({
            value: "",
            label: ""
          });

          response.data.forEach(function(patient) {
            patients.push({
              patientObject: patient,
              value: patient.id,
              label: <span>
                      <b>{patient.firstname + " " + patient.lastname}</b>
                      <br />
                      <small>{"Doc: "+patient.document+" / Tel.: "+patient.contactPhone}</small>
                    </span>
            });
          });

          this.setState({"lastPatientList": patients}, function(){
            callback(null, {
              options: patients,
              complete: true
            });
          });

        });

      });
    }else{
      callback(null, {
        options: this.state.lastPatientList,
        complete: true
      });
    }
  };

  handleDateChange(date) {

    this.setState({ formDtBirthDate: date});
  }

  toggleTab(tab) {
      if (this.state.activeTab !== tab) {
        this.setState({
          activeTab: tab
        });
      }
  }

  onDrop(accepted, rejected) {

    this.setState({
      "xmlFile": accepted[0]
    });
  }

  formatValue (value) {
    let formattedValue = value.replace(/\D/g, ''); // Remove todos os caracteres não numéricos

    if (formattedValue.length > 2) {
      formattedValue = formattedValue.slice(0, 2) + '/' + formattedValue.slice(2);
    }
    if (formattedValue.length > 5) {
      formattedValue = formattedValue.slice(0, 5) + '/' + formattedValue.slice(5);
    }

    return formattedValue.slice(0, 10); // Limita a entrada a 10 caracteres com barras
  };

  parseDate (value) {
    const parts = value.split('/');
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Subtrai 1 do mês, pois o JavaScript usa meses indexados a partir de 0
    const year = parseInt(parts[2], 10);
    
    return new Date(year, month, day);
  };

  handleKeyDownDayInput (event) {
    const value = event.target.value;

    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
    if (allowedKeys.includes(event.key)) {
      return; // Permite teclas de controle
    }

    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
      return; // Impede a entrada de caracteres não numéricos
    }
    
    // Atualiza o campo de data de nascimento com a formatação correta
    this.setState((prevState) => {
      let newValue = value + event.key;
      newValue = this.formatValue(newValue);
      if (newValue.length == 10) {
        newValue = this.parseDate(newValue);
      }
      return { formDtBirthDate: newValue };
    });

    event.preventDefault();
  };

  render() {
    if(!this.state.antecedentList || !this.state.symptomList) return ("");
    return(
        <div>

        <Nav tabs>
            <NavItem>
                <NavLink
                    className={classnames({ active: this.state.activeTab === '1' })}
                    onClick={() => { this.toggleTab('1'); }}
                    >
                    Dados Básicos
                </NavLink>
            </NavItem>
            <NavItem>
                <NavLink
                    className={classnames({ active: this.state.activeTab === '2' })}
                    onClick={() => { this.toggleTab('2'); }}
                    >
                    Dados Complementares
                </NavLink>
            </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
            <Row>
              <Col xs="12" md="12">
                <Dropzone
                  className="dropzone"
                  accept="text/xml, image/png, image/jpeg, application/pdf"
                  onDrop={this.onDrop.bind(this)}
                >
                {({ isDragActive, isDragReject }) => {

                  if (isDragReject) {
                    return "Arquivos não permitidos.";
                  }

                  if (isDragActive) {
                    return "Solte o arquivo";
                  }

                  return "" + (this.state.xmlFile ? this.state.xmlFile.name + " ("+this.state.xmlFile.size+" bytes)" :
                        "Arraste o arquivo do exame aqui... ");
                }}
                </Dropzone>
              </Col>
            </Row>
            <hr />
            <br />
            <Row>
              <Col xs="12" md="6">
                <Row className="align-items-center" style={{margin: 0}}>
                <h2 style={{margin: 0}}>Dados do Paciente</h2> 
                <span className="note">Dados obrigatórios</span>
                </Row>
                  
                  <hr />
                  {/* <Row>
                    <Col xs="12" md="12">
                      <Label>Paciente:</Label>

                      <Async
                        id="patient"
                        ref="patient"
                        autoFocus
                        filterOptions={(options, filter, currentValues) => {
                          // Do no filtering, just return all options
                          return options;
                        }}
                        cache={false}
                        loadOptions={this.getOptions.bind(this)}
                        autoload={false}
                        simpleValue
                        name="patient"
                        value={this.state.exam.patient == null ? '' : this.state.exam.patient.id}
                        onChange={this.updatePatientSelectValue}
                        openOnClick={true}
                        searchable={true}
                        isLoading={this.state.isLoading}
                      />
                    </Col>
                  </Row>
                  <hr /> */}
                  <Row>
                    <Col xs="6" md="3">
                        <Label>ID:</Label>
                        <Input type="text" id="document" ref="document" value={this.state.exam.patient.document}
                          onChange={evt => this.updatePatientInputValue(evt, "document")} placeholder="ID"/>
                    </Col>

                    <Col xs="6" md="3">
                      <Label>Documento:</Label>

                      <select className="form-control" onChange={evt => this.updatePatientInputValue(evt, "docType")} value={this.state.exam.patient.docType}>
                        <option value="NULL">Selecione</option>
                        <option value="PATIENT_DOC_CPF">CPF</option>
                        <option value="PATIENT_DOC_RG">RG</option>
                        <option value="PATIENT_DOC_SUS">CARTAO SUS</option>
                        <option value="PATIENT_DOC_PP">PASSAPORTE</option>
                        <option value="PATIENT_DOC_OUTROS">OUTROS DOCUMENTOS</option>
                        <option value="PATIENT_DOC_NO_ID">SEM DOCUMENTO</option>
                        <option value="PATIENT_DOC_EXT">EXTERNO</option>
                      </select>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col xs="6" md="3">
                      <Label>Nome</Label>
                      <Input type="text" id="firstname" ref="firstname" value={this.state.exam.patient.firstname}
                        onChange={evt => this.updatePatientInputValue(evt, "firstname")} placeholder="Nome"/>
                    </Col>

                    <Col xs="6" md="3">
                      <Label>Sobrenome</Label>
                      <Input type="text" id="lastname" ref="lastname" value={this.state.exam.patient.lastname}
                        onChange={evt => this.updatePatientInputValue(evt, "lastname")} placeholder="Sobrenome"/>
                    </Col>

                    <Col xs="6" md="3">
                      <Label>Dt. Nascimento:</Label>
                      <br />
                      <DayPickerInput
                        value={this.state.formDtBirthDate}
                        placeholder="Nascimento"
                        format="DD/MM/YYYY"
                        formatDate={formatDate}
                        parseDate={parseDate}
                        locale='pt-br'
                        onDayChange={this.handleDateChange}

                        dayPickerProps={{
                          locale: 'pt-br',
                          localeUtils: MomentLocaleUtils,
                        }}

                        inputProps={{
                          onKeyDown: this.handleKeyDownDayInput,
                          value: this.state.formDtBirthDate,
                          maxLength: 10                            
                        }}
                      />
                    </Col>
                  </Row>
                  <br />

                  <Row>
                    <Col xs="6" md="3">
                      <Label>Sexo:</Label>

                      <select className="form-control" onChange={evt => this.updatePatientInputValue(evt, "gender")} value={this.state.exam.patient.gender}>
                        <option value="NULL">Selecione</option>
                        <option value="MALE">Masculino</option>
                        <option value="FEMALE">Feminino</option>
                      </select>
                    </Col>
                  </Row>
                  <hr />
                  <br />
                  <h2>Dados do Exame</h2>
                  <hr />
                  <Row>
                    <Col xs="6" md="3">

                        <Input type="checkbox" id="urgent" ref="urgent" value={this.state.exam.urgent}
                          checked={this.state.exam.urgent}
                          onChange={evt => this.updateCheckboxValue(evt, "urgent")}/>
                          {'\u00A0'}
                          <Label htmlFor="urgent">Urgente</Label>
                    </Col>

                    <Col xs="6" md="3">
                      <Label>Tipo do exame:</Label>

                      <select className="form-control" onChange={evt => this.updateInputValue(evt, "examType")} value={this.state.exam.examType}>
                        <option value="EXAM_TYPE_ECG">ECG</option>
                        <option value="EXAM_TYPE_MAPA">MAPA</option>
                        <option value="EXAM_TYPE_HOLTER">HOLTER</option>
                      </select>
                    </Col>

                    <Col xs="12" md="12">
                        <Label>Observações:</Label>
                        <Input type="textarea" id="obs" ref="obs" value={this.state.exam.obs}
                          onChange={evt => this.updateInputValue(evt, "obs")} placeholder="Observações"/>
                    </Col>
                  </Row>
                  <hr />
                </Col>

                <Col xs="6" md="3">
                  <h2>Sintomas</h2>
                  <hr />
                  <Select
                    closeOnSelect={false}
                    multi
                    onChange={this.onSymptomSelect}
                    options={this.state.symptomList}
                    placeholder="Sintomas"
                    removeSelected={true}
                    simpleValue
                    value={this.state.selectSymptomValue}
                  />
                  <br />
                  Outros Sintomas: <br />
                  <Input type="textarea" id="otherPatientSymptoms" ref="otherPatientSymptoms" value={this.state.exam.otherPatientSymptoms}
                    onChange={evt => this.updateInputValue(evt, "otherPatientSymptoms")} placeholder="Outros"/>

                  <br />
                  <br />
                  <h2>Antecedentes</h2>
                  <hr />
                  <Select
                    closeOnSelect={false}
                    multi
                    onChange={this.onAntecedentSelect}
                    options={this.state.antecedentList}
                    placeholder="Antecedentes"
                    removeSelected={true}
                    simpleValue
                    value={this.state.selectAntecedentValue}
                  />
                  <br />
                  Outros Antecedentes: <br />
                  <Input type="textarea" id="otherPatientAntecedents" ref="otherPatientAntecedents" value={this.state.exam.otherPatientAntecedents}
                    onChange={evt => this.updateInputValue(evt, "otherPatientAntecedents")} placeholder="Outros"/>

                  <br />
                </Col>
              </Row>
            </TabPane>
          </TabContent>

          <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="2">

                <h2>Dados do Paciente</h2>
                <hr />
                <Row>
                  <Col xs="6" md="6">
                      <Label>Nome da Mãe:</Label>
                      <Input type="text" id="motherName" ref="motherName" value={this.state.exam.patient.motherName}
                        onChange={evt => this.updatePatientInputValue(evt, "motherName")} placeholder="Nome da Mãe"/>
                  </Col>

                  <Col xs="6" md="3">
                      <Label>Tel. do Paciente:</Label>
                      <Input type="text" id="contactPhone" ref="contactPhone" value={this.state.exam.patient.contactPhone}
                        onChange={evt => this.updatePatientInputValue(evt, "contactPhone")} placeholder="Tel. do Paciente"/>
                  </Col>
                </Row>

                <br />
                <Row>
                  <Col xs="6" md="3">
                      <Label>Peso (Kg):</Label>
                      <Input type="number" id="weight" ref="weight" value={this.state.exam.patient.weight}
                        onChange={evt => this.updatePatientInputValue(evt, "weight")} placeholder="Peso"/>
                  </Col>

                  <Col xs="6" md="3">
                      <Label>Altura (cm):</Label>
                      <Input type="number" id="height" ref="height" value={this.state.exam.patient.height}
                        onChange={evt => this.updatePatientInputValue(evt, "height")} placeholder="Altura"/>
                  </Col>
                </Row>

                <br />
                <h2>Solicitante</h2>
                <hr />
                <Row>
                  <Col xs="6" md="6">
                      <Label>Nome:</Label>
                      <Input type="text" id="requesterName" ref="requesterName" value={this.state.exam.requesterName}
                        onChange={evt => this.updateInputValue(evt, "requesterName")} placeholder="Nome"/>
                  </Col>

                  <Col xs="6" md="3">
                      <Label>Tel. do Solicitante:</Label>
                      <Input type="text" id="requesterContactPhone" ref="requesterContactPhone" value={this.state.exam.requesterContactPhone}
                        onChange={evt => this.updateInputValue(evt, "requesterContactPhone")} placeholder="Telefone"/>
                  </Col>
                </Row>

                <Row>
                  <Col xs="6" md="3">
                    <Label>Especialidade:</Label>

                    <Select
                      id="requesterSpeciallity"
                      ref="requesterSpeciallity"
                      autoFocus
                      options={this.state.speciallityList}
                      simpleValue
                      name="requesterSpeciallity"
                      value={this.state.exam.requesterSpeciallity == null ? '' : this.state.exam.requesterSpeciallity.id}
                      onChange={this.updateSelectValue}
                      openOnClick={true}
                      searchable={true}
                    />
                  </Col>
                </Row>
              </TabPane>
          </TabContent>

          <br />
          <Button color="success" onClick={() => { this.sendExam(); }} disabled={!this.state.buttonActive}>Enviar Exame</Button>
          <br />
          <br />

          <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
        </div>
      )
  }
}

export default ExamForm;



// WEBPACK FOOTER //
// ./src/views/client/ExamForm/ExamForm.js